module.exports = __webpack_public_path__ + "components/newsletter/static/envelope-27bd896b96eabfc9e617b771febfe2ae.svg";